// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3j-qi","head":"Table_head__2FEFa","col":"Table_col__1LP2S"};